import { TranslateHelper } from '../../helpers/injector.helper';
import { ValueAndType } from '../basic/formulaEditor.model';
import { OperationType } from '../enums/operationtype.enum';
import { ValueType } from '../enums/valuetype.enum';
import { FormulaNodeCalculator } from './formula.node.calculator';
import { AFormula, FormulaGroups } from './iformula';

export class MonthFormula extends AFormula {
    static StaticID = 'beab2206-90a0-463d-9897-146d7fbaf546';

    ID(): string {
        return MonthFormula.StaticID;
    }

    Name(): string {
        return 'Month';
    }

    Description(): string {
        return TranslateHelper.TranslatorInstance.instant('@@Gibt in Verbindung mit einer Zeitangabe den Monat aus');
    }

    Group(): string {
        return FormulaGroups.Functions;
    }

    OrderID(): number {
        return 10;
    }

    OperationType(): OperationType {
        return OperationType.Function;
    }

    OperationValue(): string {
        return this.Name() + '(' + TranslateHelper.TranslatorInstance.instant('@@Argument') + ')';
    }

    Calc(fnc: FormulaNodeCalculator, maxType: ValueType, args?: ValueAndType[]): ValueAndType {
        const retVal = new ValueAndType();
        if (maxType === ValueType.Datetime && args && args.length > 0) {
            const date = args[0].Value;
            if (date instanceof Date && !isNaN(date.getTime())) {
                retVal.Type = ValueType.Long;
                retVal.Value = date.getMonth() + 1;
            }
        }
        return retVal;
    }
}
